(function (module) {
    'use strict';

    function ViewAccountCtrl($scope, $state, Account, User, Includes, Store) {
        this.$onInit = () => {
            User
                .getCurrent({ filter: Includes.users })
                .$promise
                .then((user) => {
                    this.currentUser = user.currentUser;
                    this.account = user.account;
                });
        };

        this.save = () => {
            Account.prototype$patchAttributes(this.account)
                .$promise
                .then((account) => {
                    this.accounts = Store.setSingleModelData('accounts', account.id, account);
                    this.form.$setPristine();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });

        };

    }

    module
        .config(function ($stateProvider) {

            // Route
            $stateProvider
                .state('root.my-account.view', {
                    url: '/my-account/view',
                    data: {
                        pageTitle: 'MY_ACCOUNT_VIEW.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<my-account-view-component />',

                        },
                    },

                });
        })

        .component('myAccountViewComponent', {
            templateUrl: '/js/my-account/view-account/view-account.html',
            controller: ViewAccountCtrl,

        });

})(angular.module('rocket.components'));
